import { UPDATE_FORM } from 'redux/modules/form';

const SET_CHANGED_IDS = 'SET_CHANGED_IDS';
const RESET_CHANGED_IDS = 'RESET_CHANGED_IDS';

export const defaultState = {
    form: false,
    pages: false,
    sections: false,
    fields: false,
    options: false,
    settingsForm: false,
    sectionsIds: [],
    fieldsIds: [],
    optionsIds: []
};

export default function changedFields(state = defaultState, action) {
    switch (action.type) {
        case UPDATE_FORM: {
            return { ...state, form: true };
        }
        case SET_CHANGED_IDS: {
            const sectionsIds = action.payload.changeList.sectionsIds
                ? {
                      sectionsIds: [
                          ...new Set([
                              ...state.sectionsIds,
                              ...action.payload.changeList.sectionsIds
                          ])
                      ]
                  }
                : { sectionsIds: state.sectionsIds };

            const fieldsIds = action.payload.changeList.fieldsIds
                ? {
                      fieldsIds: [
                          ...new Set([...state.fieldsIds, ...action.payload.changeList.fieldsIds])
                      ]
                  }
                : { fieldsIds: state.fieldsIds };

            const optionsIds = action.payload.changeList.optionsIds
                ? {
                      optionsIds: [
                          ...new Set([...state.optionsIds, ...action.payload.changeList.optionsIds])
                      ]
                  }
                : { optionsIds: state.optionsIds };
            return {
                ...state,
                ...action.payload.changeList,
                ...sectionsIds,
                ...fieldsIds,
                ...optionsIds
            };
        }
        case RESET_CHANGED_IDS: {
            return defaultState;
        }
        default:
            return state;
    }
}

export function setChangedIDs(changeList = {}) {
    return {
        type: SET_CHANGED_IDS,
        payload: { changeList }
    };
}

export function resetChangedIDs() {
    return {
        type: RESET_CHANGED_IDS
    };
}
